import './completenessDetails.css'

import classNames from 'classnames'
import { CloseButton, InputDropdown } from 'components'
import { selectCompletenessCountries } from 'data/selectors'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { State } from 'store/types'
import { noop } from 'utils'

import Modal from '@mui/material/Modal'

import CompletenessDetailsContent from './CompletenessDetailsContent'
import {
  ACTIVE_CLOSED_TAB,
  CLOSED_REPORTING_TAB,
  COUNTRIES_LAST_UPDATE_TAB,
  COUNTRIES_LIST_TYPES,
  DELAYED_RTLOG_TAB,
  DELAYED_STORES_TAB,
  ZERO_REPORTING_TAB,
} from './constants'
import CountriesTable from './CountriesTable'
import type { CompletenessDetailsProps } from './types'
import useStyles from './useStyles'

function CompletenessDetails(props: CompletenessDetailsProps) {
  const classes = useStyles()
  const { t: translate } = useTranslation()
  const isFetchingDelayedStores = useSelector((state: State) => state.completeness.isFetchingDelayedStores)
  const { isLoading, list: countries } = useSelector(selectCompletenessCountries)
  const { dateCurrent, hideModal, isOpen } = props
  const options = [
    {
      label: translate('revenue.stats.completeness.delayedStores'),
      value: DELAYED_STORES_TAB,
    },
    {
      label: translate('revenue.stats.completeness.latestReports'),
      value: COUNTRIES_LAST_UPDATE_TAB,
    },
    {
      label: translate('revenue.stats.completeness.closedReporting'),
      value: CLOSED_REPORTING_TAB,
    },
    {
      label: translate('revenue.stats.completeness.zeroReporting'),
      value: ZERO_REPORTING_TAB,
    },
    {
      label: translate('revenue.stats.completeness.activeClosed'),
      value: ACTIVE_CLOSED_TAB,
    },
    {
      label: translate('revenue.stats.completeness.delayedRtlog'),
      value: DELAYED_RTLOG_TAB,
    },
  ]

  useEffect(() => {
    if (isOpen) {
      props.fetchCompletenessGeneralRevenue()
      props.fetchClosedReportingOnlyStores()
      props.fetchDelayedStores()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <Modal onClose={hideModal} open={isOpen}>
      <div className={classNames(classes.modalContent, 'modal_content completeness-details')}>
        <div className="modal_content-header flex-row header-wrapper">
          <span className="modal_content-title">
            {translate('revenue.stats.completeness.header')} ({dateCurrent})
          </span>
          <CloseButton onClick={hideModal} />
        </div>
        <CountriesTable
          countries={countries}
          isFetching={isLoading}
          onRowClick={noop}
          tableType={COUNTRIES_LIST_TYPES.NO_REPORTS}
        />
        <div className="completeness-dropdown-wrapper">
          <InputDropdown onChange={props.setSelectedValue} options={options} selectedValue={props.selectedValue} />
        </div>
        <CompletenessDetailsContent {...props} countries={countries} isFetchingDelayedStores={isFetchingDelayedStores} />
      </div>
    </Modal>
  )
}

export default CompletenessDetails
